export { AuditTrailTab } from './audit-trail-tab';
